import { Component, Input, forwardRef, HostBinding } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'websilk-text-field',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WebsilkTextField),
      multi: true
    }
  ],
  templateUrl: './ws-text-field.component.html'
})
export class WebsilkTextField implements ControlValueAccessor {
  @HostBinding('attr.id')
  externalId = '';

  @Input() id: string;
  @Input('value') _value;
  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  @Input() inlineLabelClass: string = 'col-md-3 text-md-right';
  @Input() inlineFieldClass: string = 'col-md-9';
  @Input() errorText: string = '';
  @Input() labelText: string = '';
  @Input() name: string = '';
  @Input() disabled: boolean = false;
  @Input() placeholderText: string = '';
  @Input() pattern: string = '';
  @Input() trailingText: string = '';
  @Input() trailingTextInlineClass: string = '';
  @Input('required') _required = 'false';
  get required() {
    return (this._required == 'true');
  }

  @Input('multiLine') _multiLine = 'false';
  get multiLine() {
    return (this._multiLine == 'true');
  }


  @Input() maxLength: string = '';
  @Input() fieldType: string = 'text';
  @Input('displayInline') _displayInline = 'true';
  get displayInline() {
    return (this._displayInline == 'true');
  }

  @Input() prependText: string = '';

  constructor() { }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value !== undefined) { // check for undefined, not just false values. otherwise empty strings won't update from parent
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

}



